import { NOTIFICATION_INFINITE_DURATION, NotificationAlertType } from "../interfaces/Components/alpinejs/NotificationAlert";
import { NotificationBannerType } from "../interfaces/Components/alpinejs/NotificationBanner";
import { BroadcastedNotification } from "../interfaces/Components/alpinejs/NotificationMenu";
import { addNotificationToMenu, getUserId, translate } from "../app/support/utils";
import { Store } from "../app/services/Store";
import { notifyAlert, notifyBanner } from "@/app/support/alert-and-banner";
import { getAlertNotificationFromBroadcast } from "../app/services/NotificationAdapter";

if (undefined !== window.Echo) {
    const userId = getUserId();

    if (null !== userId) {
        window.Echo.private(`notifications-user.${userId}`)
            // User notifications
            .listen('UserNotifiedByAlert', (e: ({
                title: string,
                message: string,
                type: NotificationAlertType,
                duration: number
            })) => {
                notifyAlert(
                    e.title,
                    e.message,
                    e.type,
                    e.duration,
                );
            })
            .listen('UserNotifiedByBanner', (e: ({
                message: string,
                type: NotificationBannerType
            })) => {
                notifyBanner(
                    e.message,
                    e.type,
                );
            });

        window.Echo.private('App.Models.User.' + userId)
            .notification((broadcastedContent: BroadcastedNotification) => {
                const notification = getAlertNotificationFromBroadcast(broadcastedContent);

                notifyAlert(
                    translate('Your received a notification'),
                    notification.message,
                    notification.type,
                    notification.duration,
                );

                addNotificationToMenu(notification.id, notification.message, notification.created_at_for_humans, notification.read_at);
            });
    }


    window.Echo.channel('notifications.global')
        .listen('MaintenanceWillHappens', (e: ({
            id: number,
            message: string
        })) => {
            notifyAlert(
                translate('A maintenance will happens'),
                e.message,
                'info',
                NOTIFICATION_INFINITE_DURATION,
                () => Store.storeMaintenanceId(e.id),
            );

            notifyBanner(
                e.message,
                'info',
                () => Store.storeMaintenanceId(e.id),
            );
        })
        .listen('UserNotifiedByAlert', (e: ({
            title: string
            message: string
            type: NotificationAlertType,
            duration: number
        })) => {
            notifyAlert(
                e.title,
                e.message,
                e.type,
                e.duration,
            );
        })
        .listen('UserNotifiedByBanner', (e: ({
            message: string
            type: NotificationBannerType,
        })) => {
            notifyBanner(
                e.message,
                e.type,
            );
        });


}
